module.exports = __webpack_public_path__ + "img/promotions.85f240a9.svg";